var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"preview__container"},[_c('img',{ref:"imgcontainer",staticClass:"preview__img",attrs:{"src":_vm.imgUrl,"alt":"预览图片"},on:{"&wheel":function($event){return _vm.wheelEvent.apply(null, arguments)}}}),(_vm.imageShow)?_c('div',{staticClass:"scale"},[_vm._v(" "+_vm._s(_vm.scalePercent)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }